import React from "react";
import { BookOpenIcon, EyeIcon, PlayIcon } from "lucide-react";
import { teachSteps } from "../../data/content";
const icons = [BookOpenIcon, EyeIcon, PlayIcon];
export function OpenLookTeach() {
  return <section aria-labelledby="olt-title" className="on-light bg-white" data-id="element-204" data-mp="3mcnjm18yuilg">
      <div className="container-x py-14 sm:py-20 lg:py-24" data-id="element-205" data-mp="3ragmolez2whi">
        <div className="max-w-[44rem]" data-id="element-206" data-mp="3rayso9rfsp2m">
          <p className="eyebrow" data-id="element-207" data-mp="iv59fn5q0zhv">The ready-to-teach book</p>
          <h2 id="olt-title" className="section-title mt-4" data-id="element-208" data-mp="ivos56373rwy">
            Open it. Look. <span className="text-navy underline decoration-cyan decoration-[4px] underline-offset-[6px]" data-id="element-209" data-mp="nsosd0dd60g5">Teach.</span>
          </h2>
        </div>

        <ol className="mt-8 grid gap-0 border-t-2 border-cyan md:mt-10 md:grid-cols-3 lg:mt-14" data-id="element-210" data-mp="e46sclcwrxdk">
          {teachSteps.map((step, i) => {
          const Icon = icons[i];
          return <li key={step.title} className="flex gap-4 border-b border-navy/10 py-5 md:flex-col md:gap-4 md:border-b-0 md:border-l md:px-8 md:py-10 md:first:border-l-0 md:first:pl-0" data-id="element-211" data-mp="16khk6rgp5fma" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[10px] bg-navy text-cyan md:h-14 md:w-14" data-id="element-212" data-mp="2oq9uo5xs493w">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-213" data-mp="32hwuuguue1ry" />
                </span>
                <div data-id="element-214" data-mp="2xoc51c3eke3u">
                  <h3 className="font-display text-[26px] font-extrabold uppercase leading-none text-navy md:text-[38px]" data-id="element-215" data-mp="2xo2b5df8lmsv">
                    {step.title}
                  </h3>
                  <p className="mt-1.5 max-w-[22rem] text-[15px] leading-relaxed text-body md:mt-2 md:text-base" data-id="element-216" data-mp="37fgha41p1kuz">{step.text}</p>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}